// extracted by mini-css-extract-plugin
module.exports = {"link":"link-module--link--2I16u"};